import store from '../redux/store';
import { apiV2 } from '../axios';
import { setLoader } from '../redux';

export const getLocationAndUpload = async (file, id) => {
	//check if a file needs to be uploaded
	let reqBody = {};
	if (id) {
		reqBody.userId = id;
	}
	let contentType = 'image/jpeg';
	reqBody.contentType = contentType;
	return await apiV2.post(`/file`, reqBody).then(async (res) => {
		return await imageUpload(res.data, file).then(() => {
			return res.data.location;
		});
	});
};

export const imageUpload = async ({ url, location }, file) => {
	let result = await apiV2.put(url, file).catch((error) => {
		store.dispatch(setLoader(false));
		return { error: true, response: error.response };
	});
	let response = { data: result.data, location };
	return response;
};

const videoContentTypes = {
	mp4: 'video/mp4',
	m4v: 'video/x-m4v',
	mov: 'video/quicktime',
	webm: 'video/webm',
};

const getVideoContentType = (file) => {
	if (file?.type) return file.type;
	const ext = file?.name?.split('.').pop()?.toLowerCase();
	return videoContentTypes[ext] || 'video/mp4';
};

// same /file -> pre-signed PUT flow as photos, but sends the real content type
// and throws on failure so the post is not saved pointing at a missing file
export const uploadVideo = async (file, id) => {
	const contentType = getVideoContentType(file);
	const reqBody = { contentType };
	if (id) {
		reqBody.userId = id;
	}
	try {
		const { data } = await apiV2.post(`/file`, reqBody);
		await apiV2.put(data.url, file, {
			headers: { 'Content-Type': contentType },
		});
		return data.location;
	} catch (err) {
		// the API's file errors are written for images, so keep the original for
		// debugging but show the user a video-specific message
		console.error('Video upload failed', contentType, err.response?.data || err);
		throw new Error(
			'This video could not be uploaded. Please try again, or try an MP4 file.'
		);
	}
};

export const getVideoDuration = (file) => {
	return new Promise((resolve) => {
		const video = document.createElement('video');
		const src = URL.createObjectURL(file);
		const done = (duration) => {
			URL.revokeObjectURL(src);
			resolve(duration);
		};
		video.preload = 'metadata';
		video.onloadedmetadata = () => done(video.duration * 1000);
		// browser can't decode it (e.g. some .mov codecs) - let the upload decide
		video.onerror = () => done(null);
		video.src = src;
	});
};

export const getPhotoUrl = (location, _type, quality) => {
	let qualityQuery = quality ? `&quality=${quality}` : '';
	return apiV2.get(`/file?location=${location}${qualityQuery}`).catch((err) => {
		return { error: true, message: err };
	});
};

export const getDisplayPhotofromArray = async (photos, heicSetCB) => {
	if (!!photos?.[0]?.url) {
		try {
			new URL(photos[0].url);
			return { url: photos[0].url, index: 0 };
		} catch (e) {
			return getPhotoUrl(photos[0].location).then((photoRes) => {
				return Promise.resolve({ url: photoRes.data.url, index: 0 });
			});
		}
	} else {
		const nonHeicIndex = photos.findIndex((val = {}) => {
			return !val.heic;
		});
		if (nonHeicIndex >= 0) {
			heicSetCB && heicSetCB(false);
			return Promise.resolve({
				url: URL.createObjectURL(photos[nonHeicIndex].file),
				index: nonHeicIndex,
			});
		} else {
			heicSetCB && heicSetCB(true);
			return Promise.resolve({ url: photos[0].file });
		}
	}
};

export const getAcceptedPhotoArray = (photos, acceptedExt) => {
	let acceptedFiles = [];
	let rejected = 0;
	photos.forEach((val) => {
		let verified = verifyFileType(val, acceptedExt);
		if (verified) {
			if (verified === 'heic') {
				acceptedFiles.push({ file: val, heic: true });
			} else {
				acceptedFiles.push({ file: val });
			}
		} else {
			rejected++;
		}
	});

	return Promise.resolve({ acceptedFiles, rejected });
};

export const verifyFileType = (file, acceptedExt) => {
	if (file) {
		const fileExt = file?.name
			.substr(file.name.lastIndexOf('.') + 1, file.name.length)
			.toLowerCase();

		if (acceptedExt.indexOf(fileExt) === -1) {
			return false;
		} else {
			return fileExt;
		}
	}
};

export const getDisplayPostImage = async (photo, onLoad, onError) => {
	var img = new Image();
	img.src = photo?.url || '';

	img.onload = onLoad;
	img.onerror = onError;
	return img;
};
